export const TEMPLATE_STATE_MAP = {
  JIN_YONG: 0,
  QI_YONG: 1,
}
export const TEMPLATE_STATE = {
  [TEMPLATE_STATE_MAP.JIN_YONG]: '禁用',
  [TEMPLATE_STATE_MAP.QI_YONG]: '启用',
}
